import { Component, OnInit, inject, signal } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CmspageService } from '../cmspage.service';
import { Page } from '../page';
import { switchMap } from 'rxjs/operators';

@Component({
    standalone: true,
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.css'],
    imports: []
})
export class PageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private cmspageService = inject(CmspageService);
  private titleService = inject(Title);

  readonly page = signal<Page>(undefined);
  readonly error = signal<{}>(undefined);

  ngOnInit() {
    const title = this.route.snapshot.params.slug.charAt(0).toUpperCase() +
      this.route.snapshot.params.slug.slice(1);
    this.titleService.setTitle(title);
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.cmspageService.getPage(params.get('slug'))
      )
    ).subscribe(
      (data: Page) => this.page.set(data),
      error => this.error.set(error)
    );
  }
}
